<label>Server Name</label>
<input
    type="text"
    class="form-control"
    (input)="onUpdateServerName($event)">

<p>{{ serverName }}</p>

<input
    type="text"
    class="form-control"
    [(ngModel)]="serverName2">
    
<!--<p>{{ serverName2 }}</p>-->


<button
    class="btn btn-primary"
    [disabled]="!allowNewServer"
    (click)="onCreateServer()"
    >Add Server</button>
<!--<p>{{ serverCreationStatus }}</p>-->
<p *ngIf="serverCreated; else noServer">Server was created, server is: {{ serverName2 }}</p>
<ng-template #noServer>
    <p>No server was created!</p>
</ng-template>
<!--<p [innerText]="allowNewServer"></p>-->


<hr>
<app-server *ngFor="let server of servers"></app-server>